export default __webpack_public_path__ + "static/media/KOD0160-min.e6da0d39.webp";